import React, { Component } from 'react';
import { Tabs } from 'antd';
import { judgeArr } from '@/shared/functions';
class Tab extends Component {
    render() {
        const { maxShowNum, tabList, changeTab } = this.props;
        return judgeArr(tabList) ? (<Tabs className="tab_custom_style" onChange={changeTab}>
        {tabList.map(({ label, key, num, allow }) => (<Tabs.TabPane key={key} tab={(<>
                  <span>{label}&nbsp;</span>
                  <span className="tip_num">{num > maxShowNum ? `(${maxShowNum}+)` : `(${num})`}</span>
                </>)}/>))}
      </Tabs>) : null;
    }
}
export default Tab;
